
<template>
  <main>
    <CaterawayHeader/>
    <section class="index-contanier">
      <div class="img-contanier">
        <el-image style="width: 100%; height: 100%;min-height:300px;max-height: 548px;" :src="`https://order.cateraway.com/api/file/image/${bannerImage.imageId}`" :fit="fit" :lazy="true"></el-image>
        <div class="banner-content">
            <h1 class="content-h2-title"> {{this.$t("message.home.title")}} </h1>
            <h1 class="content-h3-title">  {{this.$t("message.home.subTitle")}}  </h1>
            <section style="display:flex;justify-content:center;">
                <div class="buttons" @click="openLink(webUrl)">
                    <img style="width:25x;height:25px" src="../../assets/images/el-icon-my-shopping.png" alt="">
                    <p>{{ $t("message.buttons.linkButton") }}</p>
                </div>
                <div class="buttons" style="background:#2DA739;border-color:#2DA739;" @click="openLink(whatsappUrl)">
                    <img style="width:25x;height:25px" src="../../assets/images/el-icon-my-whatsapp.png" alt="">
                    <p>{{ $t("message.buttons.whatsApp") }}</p> 
                </div>
            </section>
        </div>
      </div>
      <div class="tips-contanier" v-if="contents.length > 0">
        <div v-for="(item,index) in contents" :key="index" class="tip-main">
          <TipsSerivesList :url="item.url" :title="item.title" :content="item.content"></TipsSerivesList>
        </div>
      </div>
      <div class="swiper-contanier" v-if="images.length > 0">
        <BannerSwiper :images="images"/>
      </div>
      <div class="activity-contanier">
        <div class="activity-main">
          <Title :title="$t('message.Indexcontent.h1')"></Title>
          <Content :content="$t('message.IndexText.h2Banner')"></Content>
          <Content v-if="this.$i18n.locale === 'zh'" :content="$t('message.IndexText.h2BannerSecond')"></Content>
          <div class="activity-content-main">
            <div v-for="(item,index) in activity" :key="index" class="activity-item">
              <div class="activity-item-img">
                <el-image class="item-img" :src="item.img" fit="cover" :lazy="true"></el-image>
              </div>
              <div>
                <h3 class="activity-item-content">{{item.content}}</h3>
                <p class="activity-item-span">{{item.span}}</p>
                <p class="item-button">
                  <el-button class="activity-item-button" type="success" size="mini" @click="$router.push(item.link)">{{item.button}}</el-button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="categary-contanier">
        <div class="categary-main">
          <Title :title="$t('message.Indexmenu.h1')"></Title>
          <Content :content="$t('message.IndexText.h2menu')"></Content>
          <div class="categarys">
            <div class="categarys-item" v-for="(item,index) in categaries" :key="index">
              <div>
                <el-image class="categarys-item-img" :src="item.img" fit="cover" :lazy="true"></el-image>
              </div>
              <div style="margin-top:30px">{{ item.content }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="partner-contanier">
        <div class="partner-main">
          <Title :title="$t('message.hezuo.h2')"></Title>
          <Content :content="$t('message.IndexText.hezuo')"></Content>
          <div class="partners">
            <div class="partner-item" v-for="(item,index) in partners" :key="index">
              <div>
                <el-image class="partner-item-img" :src="item.img" fit="cover" :lazy="true"></el-image>
              </div>
              <div style="margin-top:30px">{{ item.content }}</div>
            </div>
          </div>
        </div>
        <div class="partner-button">
          <el-button class="button">
            <template v-if="this.$i18n.locale === 'zh'">
              <router-link :to="{ path: '/client/', params: { lang: this.$i18n.locale } }">{{ $t("message.hezuo.btn") }}</router-link>
            </template>
            <template v-else>
              <router-link :to="{ path: '/en/client/', params: { lang: this.$i18n.locale } }">{{ $t("message.hezuo.btn") }}</router-link>
            </template>
          </el-button>
        </div>
      </div>
      <div class="seo-contanier">
        <div class="seo-main">
          <Title :title="$t('message.seo.h1')"></Title>
          <div class="seo-content">
            <div class="seo-content-img">
              <el-image style="width: 100%;height: 100%;" :src="require('../../assets/images/pexels-naim-benjelloun-2291367.jpg')" fit="cover" :lazy="true"></el-image>
            </div>
            <div class="seo-content-main">
              <p>{{ $t("message.seo.p1") }}</p>
              <p>{{ $t("message.seo.p2") }}</p>
              <p style="margin: 0">{{ $t("message.seo.p3") }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="faq-contanier">
        <div class="faq-main">
          <Title :title="$t('message.IndexText.faq.headerTitle')"></Title>
          <div class="feq-content">
            <div class="about-food-main">
              <h3 style="color: #000">{{ $t("message.IndexText.faq.aboutFoodTitle") }}</h3>
              <div v-for="item in 13" :key="item" style="margin-left:10px">
                <h3 style="color: #000;font-size:.9rem;font-weight:550;margin-bottom:15px">{{ $t(`message.IndexText.faq.aboutFood.faq${item}`) }}</h3>
                <div style="margin-left:10px" class="feq-content-text">{{ $t(`message.IndexText.faq.aboutFood.content${item}`) }}</div>
              </div>
            </div>
            <div class="about-payment-main">
              <h3 style="color: #000">{{ $t("message.IndexText.faq.aboutPaymentTitle") }}</h3>
              <div v-for="item in 3" :key="item" style="margin-left:10px">
                <h3 style="color: #000;font-size:.9rem;font-weight:550;margin-bottom:15px">{{ $t(`message.IndexText.faq.aboutPayment.faq${item}`) }}</h3>
                <div style="margin-left:10px" class="feq-content-text">{{ $t(`message.IndexText.faq.aboutPayment.content${item}`) }}</div>
              </div>
            </div>
            <div class="about-deliverTitle-main">
              <h3 style="color: #000">{{ $t("message.IndexText.faq.aboutDeliverTitle") }}</h3>
              <div v-for="item in 6" :key="item" style="margin-left:10px">
                <h3 style="color: #000;font-size:.9rem;font-weight:550;margin-bottom:15px">{{ $t(`message.IndexText.faq.aboutDeliver.faq${item}`) }}</h3>
                <div style="margin-left:10px" class="feq-content-text">{{ $t(`message.IndexText.faq.aboutDeliver.content${item}`) }}</div>
                <div style="margin-left:10px" v-if="item == 2 || item == 4">
                  <div  v-if="(item != 2 && $i18n.locale == 'en')  || ($i18n.locale == 'zh')" style="margin-left:10px" class="feq-content-text" v-for="e in ((item != 2 && $i18n.locale == 'zh')? 4 : 2)" :key="e">{{ $t(`message.IndexText.faq.aboutDeliver.content${item}Span${e}`) }}</div>
                </div>
              </div>
            </div>
            <div class="about-toEat-main">
              <h3 style="color: #000">{{ $t("message.IndexText.faq.aboutToEatTitle") }}</h3>
              <div v-for="item in 3" :key="item" style="margin-left:10px">
                <h3 style="color: #000;font-size:.9rem;font-weight:550;margin-bottom:15px">{{ $t(`message.IndexText.faq.aboutToEat.faq${item}`) }}</h3>
                <div style="margin-left:10px" class="feq-content-text">{{ $t(`message.IndexText.faq.aboutToEat.content${item}`) }}</div>
              </div>
            </div>
            <div class="about-order-main">
              <h3 style="color: #000">{{ $t("message.IndexText.faq.aboutOrderTitle") }}</h3>
              <div v-for="item in 5" :key="item" style="margin-left:10px">
                <h3 style="color: #000;font-size:.9rem;font-weight:550;margin-bottom:15px">{{ $t(`message.IndexText.faq.aboutOrder.faq${item}`) }}</h3>
                <div style="margin-left:10px" class="feq-content-text" v-if="item !=4 ">{{ $t(`message.IndexText.faq.aboutOrder.content${item}`) }}</div>
                <div style="margin-left:10px" v-if="item == 4">
                  <div style="margin-left:10px" class="feq-content-text" v-for="e in 3" :key="e">{{ $t(`message.IndexText.faq.aboutOrder.content${item}Span${e}`) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 彈窗廣告 -->
    <section>
      <div ref="catebday" class="catebday">
        <div style="position: absolute;top: -17px;right: -17px;; background: #fff;font-size: 28px;width: 35px;height: 35px;text-align: center;border-radius: 50%;line-height: 30px;" @click="close">×</div>
        <a href="https://order.cateraway.com">
          <img class="imgBox" :src="`https://order.cateraway.com/api/file/image/${popupImage.imageId}`" alt="" />
        </a>
      </div>
      <div class="curtain" ref="curtain" @click="close"></div>
    </section>
  </main>
</template>
<script>
import CaterawayHeader from "@/components/header";
import TipsSerivesList from "@/components/common/TipsList.vue"
import BannerSwiper from "@/components/common/banner-swiper.vue"
import MenuPackagePopup from '@/components/common/MenuPackage.vue'
import Title from '../../components/common/title.vue'
import Content from '../../components/common/content.vue'
import websiteApi from "../../../api/website";

export default {
  components: {
    CaterawayHeader ,
    TipsSerivesList ,
    BannerSwiper,
    MenuPackagePopup,
    Title,
    Content
  },
  data(){
    return {
      fit:'cover',
      banner:'https://catering-webapp.s3.ap-east-1.amazonaws.com/static/img/60%E4%BA%BA%E4%BB%BD%E6%B4%BE%E5%AF%B9%E5%A5%97%E9%A4%90%E5%B0%81%E9%9D%A2.png',
      whatsappUrl:"https://api.whatsapp.com/send?phone=85264586539&text=hello%20%E5%88%B0%E6%9C%83%E5%AE%B6,%E6%88%91%E6%83%B3%E8%A8%82%E5%88%B0%E6%9C%83%EF%BC%81%F0%9F%98%8B%F0%9F%98%8B",
      webUrl:"https://order.cateraway.com/",
      contents:[
        {
          url:require('../../assets/images/pc_icon1_icon.png'),
          title:this.$t("message.menu.span.title1"),
          content:this.$t("message.menu.span.content1")
        },
        {
          url:require('../../assets/images/pc_icon3_icon.png'),
          title:this.$t("message.menu.span.title3"),
          content:this.$t("message.menu.span.content3")
        },
        {
          url:require('../../assets/images/pc_icon2_icon.png'),
          title:this.$t("message.menu.span.title2"),
          content:this.$t("message.menu.span.content2")
        },
        {
          url:require('../../assets/images/pc_icon4_icon.png'),
          title:this.$t("message.menu.span.title4"),
          content:this.$t("message.menu.span.content4")
        }
      ],
      images: [],
      windowWidth: document.documentElement.clientWidth,
      time:null,
      menus:null,
      popupData:{},
      visible:false,
      activity:[
        {
          img:require('../../assets/images/service_content1_img.png'),
          content:this.$t("message.Indexcontent.span1"),
          span:this.$t("message.Indexcontent.p1"),
          button:this.$t('message.Indexcontent.btn1'),
          link:`${this.$i18n.locale === 'en' ? '/en' : ''}/menu/`
        },
        {
          img:require('../../assets/images/service_content2_img.png'),
          content:this.$t("message.Indexcontent.span2"),
          span:this.$t("message.Indexcontent.p2"),
          button:this.$t('message.Indexcontent.btn2'),
          link:`${this.$i18n.locale === 'en' ? '/en' : ''}/equiry/`
        },
        {
          img:require('../../assets/images/service_content3_img.png'),
          content:this.$t("message.Indexcontent.span3"),
          span:this.$t("message.Indexcontent.p3"),
          button:this.$t('message.Indexcontent.btn2'),
          link:`${this.$i18n.locale === 'en' ? '/en' : ''}/corporate-catering/`
        }
      ],
      categaries:[
        {
          img:require('../../assets/images/moactivity_kind1_icon.png'),
          content:this.$t("message.Indexmenu.span1")
        },
        {
          img:require('../../assets/images/moactivity_kind2_icon.png'),
          content:this.$t("message.Indexmenu.span2")
        },
        {
          img:require('../../assets/images/moactivity_kind3_icon.png'),
          content:this.$t("message.Indexmenu.span3")
        },
        {
          img:require('../../assets/images/moactivity_kind4_icon.png'),
          content:this.$t("message.Indexmenu.span4")
        },
        {
          img:require('../../assets/images/moactivity_kind5_icon.png'),
          content:this.$t("message.Indexmenu.span5")
        },
        {
          img:require('../../assets/images/moactivity_kind6_icon.png'),
          content:this.$t("message.Indexmenu.span6")
        }
      ],
      partners:[
        {
          img:require('../../assets/images/client1_img.png'),
          content:this.$t("message.hezuo.name1")
        },
        {
          img:require('../../assets/images/client28_img.png'),
          content:this.$t("message.hezuo.name2")
        },
        {
          img:require('../../assets/images/client3_img.png'),
          content:this.$t("message.hezuo.name3")
        },
        {
          img:require('../../assets/images/client4_img.png'),
          content:this.$t("message.hezuo.name4")
        },
        {
          img:require('../../assets/images/client5_img.png'),
          content:this.$t("message.hezuo.name5")
        },
        {
          img:require('../../assets/images/client6_img.png'),
          content:this.$t("message.hezuo.name6")
        },
      ],
      popupImage:{},
      bannerImage:{}
    }
  },
  watch: {
    windowWidth() {
      this.initImg()
    },
    '$i18n.locale'(){
      this.contents = [
        {
          url:require('../../assets/images/pc_icon1_icon.png'),
          title:this.$t("message.menu.span.title1"),
          content:this.$t("message.menu.span.content1")
        },
        {
          url:require('../../assets/images/pc_icon3_icon.png'),
          title:this.$t("message.menu.span.title3"),
          content:this.$t("message.menu.span.content3")
        },
        {
          url:require('../../assets/images/pc_icon2_icon.png'),
          title:this.$t("message.menu.span.title2"),
          content:this.$t("message.menu.span.content2")
        },
        {
          url:require('../../assets/images/pc_icon4_icon.png'),
          title:this.$t("message.menu.span.title4"),
          content:this.$t("message.menu.span.content4")
        }
      ]
      this.activity = [
        {
          img:require('../../assets/images/service_content1_img.png'),
          content:this.$t("message.Indexcontent.span1"),
          span:this.$t("message.Indexcontent.p1"),
          button:this.$t('message.Indexcontent.btn1'),
          link:`${this.$i18n.locale === 'en' ? '/en' : ''}/menu/`
        },
        {
          img:require('../../assets/images/service_content2_img.png'),
          content:this.$t("message.Indexcontent.span2"),
          span:this.$t("message.Indexcontent.p2"),
          button:this.$t('message.Indexcontent.btn2'),
          link:`${this.$i18n.locale === 'en' ? '/en' : ''}/equiry/`
        },
        {
          img:require('../../assets/images/service_content3_img.png'),
          content:this.$t("message.Indexcontent.span3"),
          span:this.$t("message.Indexcontent.p3"),
          button:this.$t('message.Indexcontent.btn2'),
          link:`${this.$i18n.locale === 'en' ? '/en' : ''}/corporate-catering/`
        }
      ]
      this.categaries = [
        {
          img:require('../../assets/images/moactivity_kind1_icon.png'),
          content:this.$t("message.Indexmenu.span1")
        },
        {
          img:require('../../assets/images/moactivity_kind2_icon.png'),
          content:this.$t("message.Indexmenu.span2")
        },
        {
          img:require('../../assets/images/moactivity_kind3_icon.png'),
          content:this.$t("message.Indexmenu.span3")
        },
        {
          img:require('../../assets/images/moactivity_kind4_icon.png'),
          content:this.$t("message.Indexmenu.span4")
        },
        {
          img:require('../../assets/images/moactivity_kind5_icon.png'),
          content:this.$t("message.Indexmenu.span5")
        },
        {
          img:require('../../assets/images/moactivity_kind6_icon.png'),
          content:this.$t("message.Indexmenu.span6")
        }
      ]
      this.partners = [
        {
          img:require('../../assets/images/client1_img.png'),
          content:this.$t("message.hezuo.name1")
        },
        {
          img:require('../../assets/images/client28_img.png'),
          content:this.$t("message.hezuo.name2")
        },
        {
          img:require('../../assets/images/client3_img.png'),
          content:this.$t("message.hezuo.name3")
        },
        {
          img:require('../../assets/images/client4_img.png'),
          content:this.$t("message.hezuo.name4")
        },
        {
          img:require('../../assets/images/client5_img.png'),
          content:this.$t("message.hezuo.name5")
        },
        {
          img:require('../../assets/images/client6_img.png'),
          content:this.$t("message.hezuo.name6")
        },
      ]
    }
  },
  mounted(){
    window.addEventListener("resize", () => {
        this.windowWidth = document.documentElement.clientWidth;
    });
    this.getImages()
    this.initImg()
  },
  methods:{
    openLink(link) {
      window.open(link, "_blank");
    },
    initImg(){
      this.images = this.images.map(e => {
        let imageId = this.windowWidth < 480 ? e.mobileImage : e.pcImage
        return {...e, imageId}
      })
      this.bannerImage.imageId = this.windowWidth < 480 ? this.bannerImage.mobileImage : this.bannerImage.pcImage 
      this.popupImage.imageId = this.windowWidth < 480 ? this.popupImage.mobileImage : this.popupImage.pcImage
    },
    getImages(){
      websiteApi.getWebsiteDiscount('0da8d60a138edba7918a6517ccd49c9c').then(result => {
        const { data } = result
        data.forEach(e => {
          if (e.discountType === "POPUP") {
            this.popupImage = e
          } else if (e.discountType === "MAIN_BANNER") {
            this.bannerImage = e
          } else {
            this.images.push(e)
          }
        });
        this.initImg()
        if (this.popupImage.id) {
          this.initCountdown()
        }
      })
    },
    initCountdown(){  
      this.time = setTimeout(() => {
        var curtain = this.$refs.curtain;
        curtain.style.display = "block";
        const catebday = this.$refs.catebday
        catebday.style.display = "block";
        this.time = null
      }, 2000);
    },
    close() {
      const catebday = this.$refs.catebday;
      var curtain = this.$refs.curtain;
      catebday.style.display = "none";
      curtain.style.display = "none";
      this.time = null
    },
    menusDetails(value) {
      this.popupData = value
      this.visible = true
    }
  },
  unmounted() {
    this.time = null
    window.removeEventListener("resize")
  },
}
</script>
<style lang="less" scoped>
.index-contanier{
  height: 100%;
  margin-top: 110px;
  @media all and (max-width: 480px) {
      margin-top: 135px;
  }
  .img-contanier{
    width: 100%;
    position: relative;
    @media all and (max-width: 850px) {
        height: 300px;
    }
    .banner-content{
          width: 100%;
          position: absolute;
          top: 50%;
          left: 50%;
          color:#fff;
          text-align: center;
          transform: translate(-50%,-50%);
          .content-h2-title, .content-h3-title{
              font-weight: 500;
              font-size: 42px;
              @media all and (max-width: 700px) {
                  font-size: 32px;
              }
          }
          .content-h3-title{
              margin: 30px 0;
              @media all and (max-width: 700px) {
                margin: 10px 0;
              }
          }
          .buttons{
              cursor: pointer;
              min-width: 160px;
              display: flex;
              align-items: center;
              justify-content: center;
              background:#EB6100;
              border:1px solid #EB6100;
              color: #fff;
              font-size: 18px;
              padding:5px;
              border-radius: 8px;
              
              @media all and (max-width: 700px) {
                  width: 150px;
                  font-size: 14px;
              }
          }
          .buttons ~ .buttons{
            margin-left: 60px;
            @media all and (max-width: 700px) {
                margin-left: 20px;
            }
          }
    }
  }
  .tips-contanier{
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    @media all and (max-width: 900px) {
        flex-wrap: wrap;
    }
    .tip-main{
      width: 100%;
      @media all and (max-width: 900px) {
          flex: 0 0 50%;
      }
    }
  }
  .swiper-contanier{
    width: 80%;
    margin: 20px auto;
    margin-bottom: 30px;
    @media (max-width: 768px) {
      width: 98%;
    }
    @media all and (max-width: 480px) {
        width: 100%;
    }
  }
  .main-menus-contanier{
    width: 80%;
    margin: auto;
    @media (max-width: 1255px) {
      width: 90%;
    }
    @media (max-width: 768px) {
      width: 98%;
    }
    .main-title {
      margin: 1% auto;
      background-color: #ff5809;
      padding: 10px 0;
      color: white;
      h2{
        margin:0 20px;
        @media (max-width: 768px) {
          font-size: 30px;
        }
      }
    }
    .main-menus-content{
      margin-bottom: 30px;
      display: flex;
      justify-content: space-between;
      @media (max-width: 768px) {
        flex-wrap:wrap;
      }
      .menus-content{
        box-shadow:1px 1px 10px #888e95;
        flex:1;
        @media (max-width: 768px) {
          flex:0 0 48%;
          margin-bottom: 3%;
        }
        @media (max-width: 380px) {
          flex:0 0 100%;
        }
        .menus{
          padding:3% 5%;
          font-size: 0.7rem;
          box-sizing: border-box;
          color:#95989d;
          .menus-title{
            font-size: 1.1rem;
            color:#eb6410;
          }
          .menus-sub-title{
            margin:3% 0;
            font-size:.8rem;
          }
        }
      }
      .menus-content ~ .menus-content {
        margin-left: 20px;
        @media (max-width: 768px) {
          margin-left: 0px;
        }
      }
    }
  }
  .activity-contanier{
    background-image: url("../../assets/images/bodybg.jpg");
    background-size: cover;
    .activity-main{
      width:70%;
      padding:3% 2%;
      margin:0 auto;
      @media (max-width: 1255px) {
        width: 90%;
      }
      .activity-content-main{
        display: flex;
        justify-content: space-around;
        @media (max-width: 768px) {
          flex-wrap: wrap;
          justify-content: space-between;
        }
        .activity-item ~ .activity-item{
          margin-left: 30px;
          @media (max-width: 768px) {
            margin-left: 0px;
          }
        }
        .activity-item{
          text-align: center;
          flex:0 0 30%;
          @media (max-width: 768px) {
            flex:0 0 48%;
          }
          @media (max-width: 480px) {
            flex:0 0 100%;
            display:flex;
            margin-bottom:3%;
            text-align: left;
          }
          .activity-item-img{
            .item-img{
              width:100%;
              height:100%;
            }
            @media (max-width: 480px) {
              flex:0 0 48%;
            }
          }
          .activity-item-content,.activity-item-span{
            margin: 20px;
          }
          .activity-item-content{
            font-size: 1.2vw;
            font-weight: 550;
            @media (max-width: 1200px) {
              font-size: 2vw;
            }
            @media (max-width: 768px) {
              font-size: 3.2vw;
            }
            @media (max-width: 480px) {
              font-size: 4.2vw;
            }
          }
          .activity-item-span{
            font-size:13px;
            color:#919599;
            font-weight: 350;
          }
          .item-button{
            @media (max-width: 480px) {
              margin:0 20px;
            }
          }
        }
      }
    }
  }
  .categary-contanier{
    padding: 3% 0 5% 0;
    background-image: url("../../assets/images/activity_bg.png");
    background-size: cover;
    .categary-main{
      width:70%;
      margin:0 auto;
      @media (max-width: 1255px) {
        width: 90%;
      }
      .categarys{
        display:flex;
        justify-content: space-around;
        @media (max-width: 768px) {
          flex-wrap: wrap;
        }
        .categarys-item{
          flex: 0 0 15%;
          text-align: center;
          color: #e8581b;
          font-weight:600;
          @media (max-width: 768px) {
            flex: 0 0 30%;
          }
        }
      }
    }
  }
  .partner-contanier{
    padding: 3% 0 5% 0;
    .partner-main{
      width:70%;
      margin:0 auto;
      @media (max-width: 1255px) {
        width: 90%;
      }
      .partners{
        display:flex;
        justify-content: space-around;
        @media (max-width: 768px) {
          flex-wrap:wrap;
        }
        .partner-item{
          flex: 0 0 15%;
          text-align: center;
          color: #e8581b;
          font-weight:600;
          @media (max-width: 768px) {
            flex:0 0 30%;
          }
          @media (max-width: 480px) {
            flex:0 0 47%
          }
        }
      }
    }

    .partner-button{
      text-align: center;
      margin: 3% 0;
      .button{
        background: #eb6410;
        border: 1px solid #eb6410;
        a {
          color: #fff;
          text-decoration: none;
        }
      }
    }
  }
  .seo-contanier{
    padding: 3% 0 5% 0;
    .seo-main{
      width:80%;
      margin:0 auto;
      @media (max-width: 1255px) {
        width: 90%;
      }
      .seo-content{
        display:flex;
        align-items: center;
        flex-wrap: wrap;
        box-shadow: 0 3px 11px 0px rgba(64, 64, 64, 0.19);
        .seo-content-img{
          flex:0 0 38%;
          @media (max-width: 1024px) {
            flex:0 0 100%;
          }
        }
        .seo-content-main{
          flex:1;
          font-size: 15px;
          color: #919599;
          padding: 2%;
          p{
            margin-bottom: 20px;
            display: -webkit-box;
            overflow: hidden;
            -webkit-box-orient: vertical
          }
        }
      }
    }
  }
  .faq-contanier{
    .faq-main {
      width:70%;
      margin:0 auto;
      @media (max-width: 1255px) {
        width: 90%;
      }
      .feq-content{
        margin: 0 0 3%;
        font-size: .825rem;
        color: #919599;
        .feq-content-text{
          margin-bottom:3%;
        } 
      }
      
    }
  }
}
.menus-button , .activity-item-button{
  margin-bottom: 1rem;
  background: #eb6410;
  border: 1px solid #eb6410;
}
.catebday {
  width: 90%;
  animation: fadeIn; /* referring directly to the animation's @keyframe declaration */
  animation-duration: 2s; /* don't forget to set a duration! */
  --animate-delay: 2s;
  // display: none;
  position: fixed;
  z-index: 999;
  left: 50%;
  display: none;
  transform: translateX(-50%);
  top: 10vh;
  .imgBox{
    width: 100%;
  }
}
.curtain {
  width: 100%;
  height: 100%;
  z-index: 900;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(20, 20, 21, 0.5);
  animation: fadeIn; /* referring directly to the animation's @keyframe declaration */
  animation-duration: 2s; /* don't forget to set a duration! */
  --animate-delay: 2s;
  display: none;
}
</style>
